interface HandleApiErrorOptions {
    redirectOnAuthError?: boolean;
    notify?: (msg: string) => void;
    onHandled?: (statusCode: number, message: string, code?: string) => void;
}

export function handleApiError(
    error: unknown,
    options?: HandleApiErrorOptions
) {
    let errorMessage = "Request failed. Please try again.";
    let errorCode: string | undefined;
    let statusCode: number | undefined;

    if (typeof error === "object" && error !== null && "response" in error) {
        const err = error as {
            response?: {
                data?: { error?: string; message?: string };
                status?: number;
            };
        };
        errorMessage = err.response?.data?.message || errorMessage;
        errorCode = err.response?.data?.error;
        statusCode = err.response?.status;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    }

    // For normal errors, notify
    if (
        options?.notify &&
        !["Token Expired", "Deactivated Account"].includes(errorCode || "")
    ) {
        options.notify(errorMessage);
    }

    // Optional extra handling
    if (options?.onHandled) {
        options.onHandled(statusCode || 0, errorMessage, errorCode);
    }

    return { errorMessage, errorCode, statusCode };
}
